
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import ListComponent from '../../global/components/List/index.vue'
import { prettyDateTime, toTitleCase } from '../../global/functions/util'
import { CustomerInvoice } from '../../global/models'

@Component({
  components: { ListComponent }
})
export default class DisputeListPage extends Vue {
  get filterOptions() {
    return [
        { text: 'Customer', key: 'customerName', type: 'string' },
        { text: 'Submitted', key: 'submitted', type: 'datetime' }
      ]
  }

  get availableColumns() {
    return [
      { text: 'Customer', value: 'customerName', display: (data: string) => toTitleCase(data), fsExclude: true },
      { text: 'Provider', value: 'providerName', display: (data: string) => toTitleCase(data) },
      { text: 'Raised By', value: 'raisedBy', display: (data: string) => toTitleCase(data) },
      { text: 'Comments', value: 'description', fsExclude: true },
      { text: 'Submitted', value: 'submitted', display: (data: string) => data === null ? '--' : prettyDateTime(data) },
      { text: 'Status', value: 'status', display: (data: string) => toTitleCase(data) },
      { text: 'Created', value: 'created', type: 'date', display: (date?: string) => prettyDateTime(date) },
      { text: 'Updated', value: 'updated', type: 'date', display: (date?: string) => prettyDateTime(date) }
    ]
  }

  get defaultColumns() {
    return ['customerName', 'raisedBy', 'submitted', 'description', 'status', 'created', 'updated']
  }

  get actions() {
    return [
      { text: 'View', method: this.renderItem }
    ]
  }

  renderItem(item: CustomerInvoice) {
    this.$router.push({ name: 'disputes-read', params: { id: item.id.toString() } })
  }
}
